/**
 * State 09 — account not activated. Replaces the entire billing UI: no
 * subscription facts, no usage card, no plan table, per
 * design_handoff_billing.
 */
import React from "react";
import Card from "../../theme/untitled/Card/Card";
import Button from "../../theme/untitled/Button/Button";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./ActivationGate.module.scss";

const ActivationGate = ({ email, onResend, onChangeEmail, disabled }) => (
  <Card className={styles.root}>
    <Card.Body>
      <span className={styles.disc}>
        <Icon name="Lock01" size={24} />
      </span>
      <h2 className={styles.title}>Activate your account to manage billing</h2>
      <p className={styles.body}>
        We sent an activation link when the account was created. Until it is
        used we cannot start a subscription or show payment details.
      </p>
      {email && (
        <div className={styles.sent}>
          <Icon name="CheckCircle" size={20} className={styles.sentIcon} />
          <span>
            Sent to <strong>{email}</strong>
          </span>
        </div>
      )}
      <div className={styles.actions}>
        <Button
          hierarchy="primary"
          disabled={disabled}
          iconLeading={<Icon name="RefreshCcw01" size={20} />}
          onClick={onResend}
        >
          Resend activation link
        </Button>
        <Button hierarchy="secondaryGray" disabled={disabled} onClick={onChangeEmail}>
          Change email address
        </Button>
      </div>
    </Card.Body>
  </Card>
);

export default ActivationGate;
